<template>
  <div class="product-card-load">
    <div class="product-card-load__image" />
    <div class="product-card-load__name-price">
      <div class="name" />
      <div class="price" />
    </div>
    <div class="product-card-load__colors">
      <div />
      <div />
      <div />
    </div>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
  .product-card-load {}

  .product-card-load__image {
    background-color: #f8f8f8;
    border-radius: 10px 10px 0 0;
    height: 300px;
    margin-bottom: 16px;
  }

  .product-card-load__name-price {
    display: flex;
    align-items: center;
    justify-content: center;

    & > * {
      background: #f8f8f8;
      height: 20px;
    }

    & .name {
      flex: 1;
    }

    & .price {
      width: 75px;
      margin-left: 46px;
    }
  }

  .product-card-load__colors {
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-left: -6px;

    & > * {
      width: 24px;
      height: 24px;
      background-color: #f8f8f8;
      border-radius: 2px;
      margin-left: 6px;
    }
  }

  .product-card-load__ratings {
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-left: -4;

    & > * {
      margin-left: 4px;
      width: 14px;
      height: 14px;
    }
  }
</style>
